import HandinLogo from '../../../../../../static/handin-logo.svg';
import TurnitinLogo from '../../../../../../static/turnitin.png';
import QuizzesLogo from '../../../../../../static/quizzes.png';

/**
 * Same static provider logos used by AssignmentProviderLogo on the Assignments list.
 * Prefer these over LTI iconUrl when the provider has a known logo.
 */
const STATIC_PROVIDER_LOGOS: Record<string, string> = {
  'hand-in': HandinLogo,
  handin: HandinLogo,
  turnitin: TurnitinLogo,
  quizzes: QuizzesLogo,
};

/**
 * Resolves the provider icon the same way as Assignments list:
 * StaticLogos[provider] || imageSrc (LTI provider.iconUrl)
 */
export const getAssignmentProviderIconSrc = ({
  provider,
  imageSrc,
}: {
  provider?: string | null;
  imageSrc?: string | null;
}): string | undefined => {
  if (!provider) {
    return imageSrc || undefined;
  }

  return STATIC_PROVIDER_LOGOS[provider] || imageSrc || undefined;
};

export default getAssignmentProviderIconSrc;
